import { useCarrinhoItemSalvar, useCarrinhoSalvar } from "./useCarrinhoService";
import api from "../../service/api";

export interface CarrinhoProdutoDTO {
  CodProduto: number;
  Src: string;
  Titulo: string;
  Vlr: number;
  VlrFormatado: string;
  CodAutor: string;
  NomAutor: string;
  CodEditora: number;
  NomEditora: string;
  Disponibilidade: string;
  Qtd: number;
  QuantidadeEmEstoque: number;
  Desconto: number;
  VlrDesconto: number;
  VlrTotal: number;
  VlrTotalFormatado: string;
  Qtdestoque: number;
  Codcarrinho: number;
  Dscsituacaoestoque: string;
  Inddestaque: number;
  Indlancamento: number;
  Indprevenda: number;
  Pathimagem: string;
  Datprevendafinal: string;
  NroItem: number;
}

export interface CarrinhoDTO {
  Codcarrinho?: number;
  CodCliente: number;
  CodEmpresa?: number;
  CodUsuario?: number;
  DatCarrinho?: string;
  CodSituacao?: number;
  Produtos: CarrinhoProdutoDTO[];
  VlrMercadoria?: number;
  VlrDesconto?: number;
  CodempresaCli?: number;
  CodAlmoxarifado?: number;
  CodAcesso?: number;
  qtdDisponivel: number;
  vlrDisponivel: number;
  qtdEncomenda: number;
  vlrEncomenda: number;
  VlrTotal?: number;
  QtdTotal: number;
}

export interface ItemCarrinhoFiltroDTO {
  Codacerto?: number;
  Codproduto?: number;
  Quantidade?: number;
  Vlrunitario?: number;
  Desconto?: number;
  Codcliente?: number;
}

interface AddProduto {
  type: "ADDPRODUTO";
  Produto: CarrinhoProdutoDTO;
}

interface RemoveProduto {
  type: "REMOVEPRODUTO";
  CodProduto: number;
}

interface EsvaziaCarrinho {
  type: "ESVAZIACARRINHO";
}
export type CartAction = AddProduto | RemoveProduto;


const CarrinhoReducer = (
  carrinho: CarrinhoDTO,
  action: CartAction
): CarrinhoDTO => {
  switch (action.type) {
    case "ADDPRODUTO":
      var carrinhoLocal = { ...carrinho };
      carrinhoLocal.Produtos = [action.Produto, ...carrinho.Produtos];
      carrinhoLocal.QtdTotal = carrinho.QtdTotal + action.Produto.Qtd;

      // if (carrinhoLocal.Codcarrinho === 0) {
      // carrinhoLocal.Codcarrinho = AddProdutoCarrinho(carrinhoLocal);
      // console.log(carrinhoLocal.Codcarrinho);
        // useCarrinhoSalvar(carrinhoLocal).then((response) => {
        //   carrinhoLocal.Codcarrinho = response.data;
        // });

        // api
        //   .post(`api/business/criacarrinho`, carrinhoLocal)
        //   .then((response) => {
        //     carrinhoLocal.Codcarrinho = response.data;
        //   });

        return carrinhoLocal;
      // } else {
      //   var filtro: CarrinhoDTO = {
      //     ...carrinhoLocal,
      //     Produtos: [{ ...action.Produto }],
      //   };

      //   return useCarrinhoItemSalvar(filtro);
      // }

    case "REMOVEPRODUTO":
      var carrinhoLocal = { ...carrinho };
      carrinhoLocal.Produtos = carrinho.Produtos?.filter(
        (p) => p.CodProduto !== action.CodProduto
      );
      return carrinhoLocal;
      // case "ESVAZIACARRINHO":
      
      //   return ;
      
  }
};

// const CarrinhoReducer = (produtos: CarrinhoProdutoDTO[], action: CartAction): CarrinhoProdutoDTO[] => {
//     switch (action.type) {
//         // case 'ADD':
//         //     return [{action.task}, ...tasks];
//         case 'REMOVEPRODUTO':
//             return produtos.filter(t => t.CodProduto !== action.CodProduto);
//     }
// }

export default CarrinhoReducer;
